import BaseService from "./BaseService";

export default class FormsService extends BaseService {

  constructor() {
    super('forms')
  }

  contact(data: any) {
    return new Promise((resolve, reject) => {
      this.api.post(`${this.API_PATH}contact`, data)
        .then(res => {
          resolve(res)
        })
        .catch((err) => {
          reject(err)
        })
    })
  }
  newsletterUnsubscribe(data: any) {
    return new Promise((resolve, reject) => {
      this.api.post(`${this.API_PATH}newsletter-unsubscribe`, data)
        .then(res => {
          resolve(res)
        })
        .catch((err) => {
          reject(err)
        })
    })
  }
}